import styled from "@emotion/styled";

export const Container = styled.div`
  overflow-y: scroll;
  height: 21rem;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const MyIconButton = styled.div`
  height: 3rem;
  width: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d4e2f3;
  border: 1px solid #d2d2d2;
  border-radius: 50%;
  margin-left: 1rem;
  transition: all 0.2s;
  :hover {
    cursor: pointer;
  }
`;

export const Relative = styled.div`
  width: 100%;
  height: 48px;
  position: relative;
  margin: 0;
  padding: 0;
`;
export const ButtonCopiar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 106px;
  height: 32px;
  right: 6px;
  top: 5%;
  background: #d4e2f3;
  color: #046af3;
  border-radius: 6px;
  transition: all ease-in-out 0.2s;
  :hover {
    background-color: #024aae;
    color: white;
    cursor: pointer;
  }
`;

export const ButtonSalvar = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 42px;
  color: #fff;
  font-weight: 600;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.24);
  border-radius: 8px;
  cursor: pointer;
`;
export const ErrorMessage = styled.div`
  margin-top: 5px;
  margin-left: 1rem;
  font-size: 12px;
  color: #ff4d4f;
`;

export const WhatsappBusiness = styled.div`
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
  gap: 15px;

  .button {
    display: flex;
    padding: 10px 15px;
    background: #046af3;
    color: #fff;
    border-radius: 8px;
  }
`;

export const MyLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background: #1877f2;
  font-family: "Poppins";
  font-style: normal;
  text-align: center;
  gap: 0.5rem;
  letter-spacing: -0.02em;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.24);
  border-radius: 4px;
  padding: 9px 0;
  border: 1px solid #acd0f6;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  color: #fff;
  width: 190px;

  :hover {
    cursor: pointer;
    color: #fff;
    background-color: #7887ab;
    transition: 0.2s ease-in-out;
  }
`;

export const LinkTemplates = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  background-color: #f3f5f9;
  width: 98%;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  padding: 12px 14px;
  gap: 10px;
  margin-top: 15px;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #dae0f5;
    border-radius: 10px;
    color: #2624cd;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .title {
    font-weight: bold;
  }

  .text {
    color: #71719e;
    font-size: 12px;
  }

  i {
    color: #636363;
  }
`;
